module.exports = __webpack_public_path__ + "static/champions-35a2665353abaf930a481b3cfb84fe11.jpg";